'use client';

import { c as _c } from "react/compiler-runtime";
import '@/global.css';
import classnames from 'classnames';
import Body from '@/components/body';
import ErrorTitle from '@/components/error-title';
import ErrorView from '@/views/error-view';
import Html from '@/components/html';
import locales from '@cache/locales.json';
const className = classnames('flex', 'flex-1', 'min-h-screen', 'items-center', 'justify-center');
const GlobalError = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <head><link rel="stylesheet" href="/theme.css" /></head>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Html locale={locales.defaultLocale}>{t0}<Body><main className={className}><ErrorView name="personly"><ErrorTitle>An Error Has Occurred</ErrorTitle></ErrorView></main></Body></Html>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default GlobalError;